<template>
  <SheetModal
    class="EditSeasonModalView"
    data-theme="light"
    aria-label="Edit the season"
    :aria-busy="isRequesting || isSaving"
    @close="$emit('close')"
  >
    <SeasonFormView
      v-bind="{ seasonId }"
      v-model:isRequesting="isRequesting"
      title="Edit the season"
      @cancel="$emit('close')"
      @submit="handleSubmit"
    />
  </SheetModal>
</template>

<script lang="ts" setup>
import SheetModal from "@/components/SheetModal.vue";
import { supabaseClient } from "@/lib/database/supabase";
import useModalStore from "@/stores/useModalStore";
import useSeasonStore from "@/stores/useSeasonStore";
import { SeasonFormPayload } from "@/views/commish/SeasonFormView.types";
import SeasonFormView from "@/views/commish/SeasonFormView.vue";
import { ref } from "vue";

defineEmits<{
  close: [],
}>();

const {
  seasonId,
} = defineProps<{
  seasonId: string,
}>();

const {
  closeActiveModal,
} = useModalStore();

const {
  fetchSeason,
  fetchHomeSeasons,
} = useSeasonStore();

const isRequesting = ref(true);
const isSaving = ref(false);

async function handleSubmit (payload: SeasonFormPayload | undefined) {
  if (!payload) return;

  isSaving.value = true;

  const {
    error,
  } = await supabaseClient
    .from("seasons")
    .update(payload.season)
    .eq("id", seasonId);

  if (error) {
    alert(error.message);
  } else {
    fetchSeason(seasonId);
    fetchHomeSeasons();

    closeActiveModal();
  }

  isSaving.value = false;
}
</script>
